var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("sui-form", { attrs: { size: "medium" } }, [
    _c("div", { staticClass: "section portfolio-information" }, [
      _c(
        "div",
        { staticClass: "section-header" },
        [_c("sui-header", { tag: "h5" }, [_vm._v("PORTFOLIO INFORMATION")])],
        1
      ),
      _c(
        "div",
        { staticClass: "section-content" },
        [
          _c(
            "sui-grid",
            [
              _c(
                "sui-grid-row",
                [
                  _c(
                    "sui-grid-column",
                    { attrs: { width: 8 } },
                    [
                      _c("sui-form-field", { attrs: { required: "" } }, [
                        _c("label", [_vm._v("Account Name")]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.trim",
                              value:
                                _vm.$v.strategy.Financial_Account_Name__c
                                  .$model,
                              expression:
                                "$v.strategy.Financial_Account_Name__c.$model",
                              modifiers: { trim: true },
                            },
                          ],
                          class: {
                            "is-invalid":
                              _vm.submitted &&
                              _vm.$v.strategy.Financial_Account_Name__c.$error,
                          },
                          attrs: {
                            type: "text",
                            name: "account-name",
                            placeholder: "Account Name",
                          },
                          domProps: {
                            value:
                              _vm.$v.strategy.Financial_Account_Name__c.$model,
                          },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.$v.strategy.Financial_Account_Name__c,
                                "$model",
                                $event.target.value.trim()
                              )
                            },
                            blur: function ($event) {
                              return _vm.$forceUpdate()
                            },
                          },
                        }),
                        _vm.submitted &&
                        !_vm.$v.strategy.Financial_Account_Name__c.required
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(" Enter the account name. "),
                            ])
                          : _vm._e(),
                      ]),
                      _c("sui-form-field", { attrs: { required: "" } }, [
                        _c("label", [_vm._v("Account Number")]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.trim",
                              value:
                                _vm.$v.strategy.Custodian_Account_Number__c
                                  .$model,
                              expression:
                                "$v.strategy.Custodian_Account_Number__c.$model",
                              modifiers: { trim: true },
                            },
                          ],
                          class: {
                            "is-invalid":
                              _vm.submitted &&
                              _vm.$v.strategy.Custodian_Account_Number__c
                                .$error,
                          },
                          attrs: {
                            type: "text",
                            name: "account-number",
                            placeholder: "Account Number",
                          },
                          domProps: {
                            value:
                              _vm.$v.strategy.Custodian_Account_Number__c
                                .$model,
                          },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.$v.strategy.Custodian_Account_Number__c,
                                "$model",
                                $event.target.value.trim()
                              )
                            },
                            blur: function ($event) {
                              return _vm.$forceUpdate()
                            },
                          },
                        }),
                        _vm.submitted &&
                        !_vm.$v.strategy.Custodian_Account_Number__c.required
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(" Enter the account number. "),
                            ])
                          : _vm._e(),
                      ]),
                      _c("sui-form-field", { attrs: { required: "" } }, [
                        _c("label", [_vm._v("Account Master Code")]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.trim",
                              value:
                                _vm.$v.strategy.Account_Master_Code__c.$model,
                              expression:
                                "$v.strategy.Account_Master_Code__c.$model",
                              modifiers: { trim: true },
                            },
                          ],
                          class: {
                            "is-invalid":
                              _vm.submitted &&
                              _vm.$v.strategy.Account_Master_Code__c.$error,
                          },
                          attrs: {
                            type: "text",
                            name: "account-master-code",
                            placeholder: "Account Master Code",
                          },
                          domProps: {
                            value:
                              _vm.$v.strategy.Account_Master_Code__c.$model,
                          },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.$v.strategy.Account_Master_Code__c,
                                "$model",
                                $event.target.value.trim()
                              )
                            },
                            blur: function ($event) {
                              return _vm.$forceUpdate()
                            },
                          },
                        }),
                        _vm.submitted &&
                        !_vm.$v.strategy.Account_Master_Code__c.required
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(" Enter the account master code. "),
                            ])
                          : _vm._e(),
                      ]),
                      _c("sui-form-field", { attrs: { required: "" } }, [
                        _c("label", [_vm._v("Custodian")]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.trim",
                              value: _vm.$v.strategy.Custodian__c.$model,
                              expression: "$v.strategy.Custodian__c.$model",
                              modifiers: { trim: true },
                            },
                          ],
                          class: {
                            "is-invalid":
                              _vm.submitted &&
                              _vm.$v.strategy.Custodian__c.$error,
                          },
                          attrs: {
                            type: "text",
                            name: "custodian",
                            placeholder: "Custodian",
                          },
                          domProps: {
                            value: _vm.$v.strategy.Custodian__c.$model,
                          },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.$v.strategy.Custodian__c,
                                "$model",
                                $event.target.value.trim()
                              )
                            },
                            blur: function ($event) {
                              return _vm.$forceUpdate()
                            },
                          },
                        }),
                        _vm.submitted && !_vm.$v.strategy.Custodian__c.required
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(" Enter the custodian. "),
                            ])
                          : _vm._e(),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "sui-grid-column",
                    { attrs: { width: 8 } },
                    [
                      _c("sui-form-field", { attrs: { required: "" } }, [
                        _c("label", [_vm._v("Advisor")]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.trim",
                              value: _vm.$v.strategy.Advisor__c.$model,
                              expression: "$v.strategy.Advisor__c.$model",
                              modifiers: { trim: true },
                            },
                          ],
                          class: {
                            "is-invalid":
                              _vm.submitted &&
                              _vm.$v.strategy.Advisor__c.$error,
                          },
                          attrs: {
                            type: "text",
                            name: "advisor",
                            placeholder: "Advisor",
                          },
                          domProps: {
                            value: _vm.$v.strategy.Advisor__c.$model,
                          },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.$v.strategy.Advisor__c,
                                "$model",
                                $event.target.value.trim()
                              )
                            },
                            blur: function ($event) {
                              return _vm.$forceUpdate()
                            },
                          },
                        }),
                        _vm.submitted && !_vm.$v.strategy.Advisor__c.required
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(" Enter the advisor. "),
                            ])
                          : _vm._e(),
                      ]),
                      _c("sui-form-field", { attrs: { required: "" } }, [
                        _c("label", [_vm._v("Relationship Name")]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.trim",
                              value:
                                _vm.$v.strategy.Relationship_Name__c.$model,
                              expression:
                                "$v.strategy.Relationship_Name__c.$model",
                              modifiers: { trim: true },
                            },
                          ],
                          class: {
                            "is-invalid":
                              _vm.submitted &&
                              _vm.$v.strategy.Relationship_Name__c.$error,
                          },
                          attrs: {
                            type: "text",
                            name: "relationship-name",
                            placeholder: "Relationship Name",
                          },
                          domProps: {
                            value: _vm.$v.strategy.Relationship_Name__c.$model,
                          },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.$v.strategy.Relationship_Name__c,
                                "$model",
                                $event.target.value.trim()
                              )
                            },
                            blur: function ($event) {
                              return _vm.$forceUpdate()
                            },
                          },
                        }),
                        _vm.submitted &&
                        !_vm.$v.strategy.Relationship_Name__c.required
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(" Enter the relationship name. "),
                            ])
                          : _vm._e(),
                      ]),
                      _c(
                        "sui-form-field",
                        { attrs: { required: "" } },
                        [
                          _c("label", [_vm._v("Fee Schedule")]),
                          _c("sui-dropdown", {
                            class: {
                              "is-invalid":
                                _vm.submitted &&
                                _vm.$v.strategy.Fee_Schedule__c.$error,
                            },
                            attrs: {
                              selection: "",
                              search: "",
                              direction: "downward",
                              placeholder: "Fee Schedule",
                              options: _vm.feeSchedules,
                            },
                            model: {
                              value: _vm.$v.strategy.Fee_Schedule__c.$model,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.$v.strategy.Fee_Schedule__c,
                                  "$model",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "$v.strategy.Fee_Schedule__c.$model",
                            },
                          }),
                          _vm.submitted &&
                          !_vm.$v.strategy.Fee_Schedule__c.required
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v(" Enter the fee schedule. "),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "sui-form-field",
                        { attrs: { required: "" } },
                        [
                          _c("label", [_vm._v("Fee Minimum")]),
                          _c("currency-input", {
                            class: {
                              "is-invalid":
                                _vm.submitted &&
                                _vm.$v.strategy.Fee_Minimum__c.$error,
                            },
                            attrs: {
                              type: "text",
                              name: "fee-minimum",
                              placeholder: "Fee Minimum",
                            },
                            model: {
                              value: _vm.$v.strategy.Fee_Minimum__c.$model,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.$v.strategy.Fee_Minimum__c,
                                  "$model",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "$v.strategy.Fee_Minimum__c.$model",
                            },
                          }),
                          _vm.submitted &&
                          !_vm.$v.strategy.Fee_Minimum__c.required
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v(" Enter the fee minimum. "),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "sui-grid",
            { staticClass: "client-info" },
            [
              _c(
                "sui-grid-row",
                [
                  _c(
                    "sui-grid-column",
                    { attrs: { width: 8 } },
                    [
                      _c("sui-form-field", { attrs: { required: "" } }, [
                        _c("label", [_vm._v("Client Name")]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.trim",
                              value: _vm.$v.strategy.Client_Name__c.$model,
                              expression: "$v.strategy.Client_Name__c.$model",
                              modifiers: { trim: true },
                            },
                          ],
                          class: {
                            "is-invalid":
                              _vm.submitted &&
                              _vm.$v.strategy.Client_Name__c.$error,
                          },
                          attrs: {
                            type: "text",
                            name: "client-name",
                            placeholder: "Client Name",
                          },
                          domProps: {
                            value: _vm.$v.strategy.Client_Name__c.$model,
                          },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.$v.strategy.Client_Name__c,
                                "$model",
                                $event.target.value.trim()
                              )
                            },
                            blur: function ($event) {
                              return _vm.$forceUpdate()
                            },
                          },
                        }),
                        _vm.submitted &&
                        !_vm.$v.strategy.Client_Name__c.required
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(" Enter the client name. "),
                            ])
                          : _vm._e(),
                      ]),
                      _c("sui-form-field", { attrs: { required: "" } }, [
                        _c("label", [_vm._v("Client Address")]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.trim",
                              value: _vm.$v.strategy.Client_Street__c.$model,
                              expression: "$v.strategy.Client_Street__c.$model",
                              modifiers: { trim: true },
                            },
                          ],
                          class: {
                            "is-invalid":
                              _vm.submitted &&
                              _vm.$v.strategy.Client_Street__c.$error,
                          },
                          attrs: {
                            type: "text",
                            name: "client-street",
                            placeholder: "Street",
                          },
                          domProps: {
                            value: _vm.$v.strategy.Client_Street__c.$model,
                          },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.$v.strategy.Client_Street__c,
                                "$model",
                                $event.target.value.trim()
                              )
                            },
                            blur: function ($event) {
                              return _vm.$forceUpdate()
                            },
                          },
                        }),
                        _vm.submitted &&
                        !_vm.$v.strategy.Client_Street__c.required
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(" Enter the street. "),
                            ])
                          : _vm._e(),
                      ]),
                      _c(
                        "sui-form-field",
                        [
                          _c(
                            "sui-form-fields",
                            [
                              _c(
                                "sui-form-field",
                                { attrs: { required: "", width: "eight" } },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model.trim",
                                        value:
                                          _vm.$v.strategy.Client_City__c.$model,
                                        expression:
                                          "$v.strategy.Client_City__c.$model",
                                        modifiers: { trim: true },
                                      },
                                    ],
                                    class: {
                                      "is-invalid":
                                        _vm.submitted &&
                                        _vm.$v.strategy.Client_City__c.$error,
                                    },
                                    attrs: {
                                      type: "text",
                                      name: "joint-client-city",
                                      placeholder: "City",
                                    },
                                    domProps: {
                                      value:
                                        _vm.$v.strategy.Client_City__c.$model,
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.$v.strategy.Client_City__c,
                                          "$model",
                                          $event.target.value.trim()
                                        )
                                      },
                                      blur: function ($event) {
                                        return _vm.$forceUpdate()
                                      },
                                    },
                                  }),
                                  _vm.submitted &&
                                  !_vm.$v.strategy.Client_City__c.required
                                    ? _c(
                                        "div",
                                        { staticClass: "invalid-feedback" },
                                        [_vm._v(" Enter the city. ")]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                              _c(
                                "sui-form-field",
                                { attrs: { required: "", width: "five" } },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model.trim",
                                        value:
                                          _vm.$v.strategy.Client_State__c
                                            .$model,
                                        expression:
                                          "$v.strategy.Client_State__c.$model",
                                        modifiers: { trim: true },
                                      },
                                    ],
                                    class: {
                                      "is-invalid":
                                        _vm.submitted &&
                                        _vm.$v.strategy.Client_State__c.$error,
                                    },
                                    attrs: {
                                      type: "text",
                                      name: "joint-client-state",
                                      placeholder: "State",
                                    },
                                    domProps: {
                                      value:
                                        _vm.$v.strategy.Client_State__c.$model,
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.$v.strategy.Client_State__c,
                                          "$model",
                                          $event.target.value.trim()
                                        )
                                      },
                                      blur: function ($event) {
                                        return _vm.$forceUpdate()
                                      },
                                    },
                                  }),
                                  _vm.submitted &&
                                  !_vm.$v.strategy.Client_State__c.required
                                    ? _c(
                                        "div",
                                        { staticClass: "invalid-feedback" },
                                        [_vm._v(" Enter the state. ")]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                              _c(
                                "sui-form-field",
                                { attrs: { required: "", width: "three" } },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model.trim",
                                        value:
                                          _vm.$v.strategy.Client_Zip_Code__c
                                            .$model,
                                        expression:
                                          "$v.strategy.Client_Zip_Code__c.$model",
                                        modifiers: { trim: true },
                                      },
                                    ],
                                    class: {
                                      "is-invalid":
                                        _vm.submitted &&
                                        _vm.$v.strategy.Client_Zip_Code__c
                                          .$error,
                                    },
                                    attrs: {
                                      type: "text",
                                      name: "joint-account-zip-code",
                                      placeholder: "Zip",
                                    },
                                    domProps: {
                                      value:
                                        _vm.$v.strategy.Client_Zip_Code__c
                                          .$model,
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.$v.strategy.Client_Zip_Code__c,
                                          "$model",
                                          $event.target.value.trim()
                                        )
                                      },
                                      blur: function ($event) {
                                        return _vm.$forceUpdate()
                                      },
                                    },
                                  }),
                                  _vm.submitted &&
                                  !_vm.$v.strategy.Client_Zip_Code__c.required
                                    ? _c(
                                        "div",
                                        { staticClass: "invalid-feedback" },
                                        [_vm._v(" Enter the zip code. ")]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("sui-form-field", { attrs: { required: "" } }, [
                        _c("label", [_vm._v("Client Email")]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.trim",
                              value: _vm.$v.strategy.Client_Email__c.$model,
                              expression: "$v.strategy.Client_Email__c.$model",
                              modifiers: { trim: true },
                            },
                          ],
                          class: {
                            "is-invalid":
                              _vm.submitted &&
                              _vm.$v.strategy.Client_Email__c.$error,
                          },
                          attrs: {
                            type: "text",
                            name: "client-email",
                            placeholder: "Email",
                          },
                          domProps: {
                            value: _vm.$v.strategy.Client_Email__c.$model,
                          },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.$v.strategy.Client_Email__c,
                                "$model",
                                $event.target.value.trim()
                              )
                            },
                            blur: function ($event) {
                              return _vm.$forceUpdate()
                            },
                          },
                        }),
                        _vm.submitted &&
                        !_vm.$v.strategy.Client_Email__c.required
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(" Enter the client email. "),
                            ])
                          : _vm._e(),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "sui-grid-column",
                    { attrs: { width: 8 } },
                    [
                      _c("sui-form-field", [
                        _c("label", [_vm._v("Joint Client Name")]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.strategy.Joint_Client_Name__c,
                              expression: "strategy.Joint_Client_Name__c",
                            },
                          ],
                          attrs: {
                            type: "text",
                            name: "joint-client-name",
                            placeholder: "Joint Client Name",
                          },
                          domProps: {
                            value: _vm.strategy.Joint_Client_Name__c,
                          },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.strategy,
                                "Joint_Client_Name__c",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                      _c(
                        "sui-form-field",
                        [
                          _c("label", [_vm._v("Joint Client Address")]),
                          _c("sui-form-field", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.strategy.Joint_Client_Street__c,
                                  expression: "strategy.Joint_Client_Street__c",
                                },
                              ],
                              attrs: {
                                type: "text",
                                name: "joint-client-street",
                                placeholder: "Street",
                              },
                              domProps: {
                                value: _vm.strategy.Joint_Client_Street__c,
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.strategy,
                                    "Joint_Client_Street__c",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "sui-form-field",
                        [
                          _c(
                            "sui-form-fields",
                            { attrs: { "equal-width": "" } },
                            [
                              _c(
                                "sui-form-field",
                                { attrs: { width: "eight" } },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.strategy.Joint_Client_City__c,
                                        expression:
                                          "strategy.Joint_Client_City__c",
                                      },
                                    ],
                                    attrs: {
                                      type: "text",
                                      name: "joint-client-city",
                                      placeholder: "City",
                                    },
                                    domProps: {
                                      value: _vm.strategy.Joint_Client_City__c,
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.strategy,
                                          "Joint_Client_City__c",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ]
                              ),
                              _c(
                                "sui-form-field",
                                { attrs: { width: "five" } },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.strategy.Joint_Client_State__c,
                                        expression:
                                          "strategy.Joint_Client_State__c",
                                      },
                                    ],
                                    attrs: {
                                      type: "text",
                                      name: "joint-client-state",
                                      placeholder: "State",
                                    },
                                    domProps: {
                                      value: _vm.strategy.Joint_Client_State__c,
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.strategy,
                                          "Joint_Client_State__c",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ]
                              ),
                              _c(
                                "sui-form-field",
                                { attrs: { width: "three" } },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.strategy.Joint_Client_Zip_Code__c,
                                        expression:
                                          "strategy.Joint_Client_Zip_Code__c",
                                      },
                                    ],
                                    attrs: {
                                      type: "text",
                                      name: "joint-account-zip-code",
                                      placeholder: "Zip",
                                    },
                                    domProps: {
                                      value:
                                        _vm.strategy.Joint_Client_Zip_Code__c,
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.strategy,
                                          "Joint_Client_Zip_Code__c",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("sui-form-field", [
                        _c("label", [_vm._v("Joint Client Email")]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.strategy.Joint_Client_Email__c,
                              expression: "strategy.Joint_Client_Email__c",
                            },
                          ],
                          attrs: {
                            type: "text",
                            name: "joint-client-email",
                            placeholder: "Email",
                          },
                          domProps: {
                            value: _vm.strategy.Joint_Client_Email__c,
                          },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.strategy,
                                "Joint_Client_Email__c",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { "margin-top": "1em" } },
            [
              _c(
                "sui-form-fields",
                { attrs: { inline: "" } },
                [
                  _c("label", [
                    _vm._v(
                      "Has the client been provided a copy of EverSource Wealth Advisors Form ADV, Form CRS, and Privacy Policy?"
                    ),
                  ]),
                  _c(
                    "sui-form-field",
                    [
                      _c("sui-checkbox", {
                        attrs: { name: "form-adv-and-privacy-policy" },
                        model: {
                          value:
                            _vm.strategy
                              .Has_Received_Form_ADV_And_Privacy_Policy__c,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.strategy,
                              "Has_Received_Form_ADV_And_Privacy_Policy__c",
                              $$v
                            )
                          },
                          expression:
                            "strategy.Has_Received_Form_ADV_And_Privacy_Policy__c",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "sui-form-fields",
                { attrs: { inline: "" } },
                [
                  _c("label", [
                    _vm._v(
                      "Has the client signed a new or an updated Investment Policy Statement that includes this financial account?"
                    ),
                  ]),
                  _c(
                    "sui-form-field",
                    [
                      _c("sui-checkbox", {
                        attrs: { name: "has-signed-new-or-update-IPS" },
                        model: {
                          value: _vm.strategy.Has_Signed_New_Or_Updated_IPS__c,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.strategy,
                              "Has_Signed_New_Or_Updated_IPS__c",
                              $$v
                            )
                          },
                          expression:
                            "strategy.Has_Signed_New_Or_Updated_IPS__c",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "section investment-model section" }, [
      _c(
        "div",
        { staticClass: "section-header" },
        [_c("sui-header", { tag: "h5" }, [_vm._v("INVESTMENT MODEL")])],
        1
      ),
      _c(
        "div",
        { staticClass: "section-content" },
        [
          _c(
            "sui-grid",
            [
              _c(
                "sui-grid-row",
                [
                  _c(
                    "sui-grid-column",
                    { attrs: { width: 8 } },
                    [
                      _c(
                        "sui-form-field",
                        { attrs: { required: "" } },
                        [
                          _c("label", [_vm._v("Investment Model")]),
                          _c("sui-dropdown", {
                            class: {
                              "is-invalid":
                                _vm.submitted &&
                                _vm.$v.strategy.Investment_Model__c.$error,
                            },
                            attrs: {
                              selection: "",
                              search: "",
                              direction: "downward",
                              placeholder: "Search Investment Models...",
                              options: _vm.investmentModels,
                            },
                            model: {
                              value: _vm.$v.strategy.Investment_Model__c.$model,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.$v.strategy.Investment_Model__c,
                                  "$model",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression:
                                "$v.strategy.Investment_Model__c.$model",
                            },
                          }),
                          _vm.submitted &&
                          !_vm.$v.strategy.Investment_Model__c.required
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v(" Enter the investment model. "),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "sui-form-field",
                        { attrs: { required: "" } },
                        [
                          _c("label", [_vm._v("Trading Authority")]),
                          _c("sui-dropdown", {
                            class: {
                              "is-invalid":
                                _vm.submitted &&
                                _vm.$v.strategy.Trading_Authority__c.$error,
                            },
                            attrs: {
                              selection: "",
                              direction: "downward",
                              placeholder: "Trading Authority",
                              options: _vm.tradingAuthorities,
                            },
                            model: {
                              value:
                                _vm.$v.strategy.Trading_Authority__c.$model,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.$v.strategy.Trading_Authority__c,
                                  "$model",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression:
                                "$v.strategy.Trading_Authority__c.$model",
                            },
                          }),
                          _vm.submitted &&
                          !_vm.$v.strategy.Trading_Authority__c.required
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v(" Enter the trading authority. "),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "section cash-management" }, [
      _c(
        "div",
        { staticClass: "section-header" },
        [_c("sui-header", { tag: "h5" }, [_vm._v("CASH MANAGEMENT")])],
        1
      ),
      _c(
        "div",
        { staticClass: "section-content" },
        [
          _c(
            "sui-grid",
            [
              _c(
                "sui-grid-row",
                [
                  _c(
                    "sui-grid-column",
                    { attrs: { width: 8 } },
                    [
                      _c("sui-form-field", [
                        _c("label", [_vm._v("Cash Target (%)")]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.number",
                              value: _vm.strategy.Cash_Target_Percentage__c,
                              expression: "strategy.Cash_Target_Percentage__c",
                              modifiers: { number: true },
                            },
                          ],
                          attrs: {
                            type: "number",
                            name: "cash-target-percentage",
                            placeholder: "Cash Target (%)",
                          },
                          domProps: {
                            value: _vm.strategy.Cash_Target_Percentage__c,
                          },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.strategy,
                                "Cash_Target_Percentage__c",
                                _vm._n($event.target.value)
                              )
                            },
                            blur: function ($event) {
                              return _vm.$forceUpdate()
                            },
                          },
                        }),
                      ]),
                      _c(
                        "sui-form-fields",
                        [
                          _c(
                            "sui-form-fields",
                            { attrs: { inline: "" } },
                            [
                              _c("label", [_vm._v("Cash Distributions")]),
                              _c(
                                "sui-form-field",
                                [
                                  _c("sui-checkbox", {
                                    attrs: { name: "is-cash-contributions" },
                                    model: {
                                      value:
                                        _vm.strategy.Is_Cash_Distributions__c,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.strategy,
                                          "Is_Cash_Distributions__c",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "strategy.Is_Cash_Distributions__c",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.strategy.Is_Cash_Distributions__c
                            ? _c(
                                "sui-form-field",
                                { attrs: { width: "twelve" } },
                                [
                                  _c("label", [_vm._v("Amount")]),
                                  _c("currency-input", {
                                    attrs: {
                                      name: "amount",
                                      placeholder: "Amount",
                                    },
                                    model: {
                                      value: _vm.strategy.Amount__c,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.strategy, "Amount__c", $$v)
                                      },
                                      expression: "strategy.Amount__c",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "sui-grid-column",
                    { attrs: { width: 8 } },
                    [
                      _c(
                        "sui-form-field",
                        [
                          _c("label", [_vm._v("Cash Target ($)")]),
                          _c("currency-input", {
                            attrs: {
                              name: "cash-target-dollar",
                              placeholder: "Cash Target ($)",
                            },
                            model: {
                              value: _vm.strategy.Cash_Target_Dollars__c,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.strategy,
                                  "Cash_Target_Dollars__c",
                                  $$v
                                )
                              },
                              expression: "strategy.Cash_Target_Dollars__c",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "sui-form-field",
                        [
                          _c("label", [_vm._v("Frequency")]),
                          _c("sui-dropdown", {
                            attrs: {
                              selection: "",
                              direction: "downward",
                              placeholder: "Frequency",
                              options: _vm.cashManagementFrequencyOptions,
                            },
                            model: {
                              value: _vm.strategy.Cash_Management_Frequency__c,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.strategy,
                                  "Cash_Management_Frequency__c",
                                  $$v
                                )
                              },
                              expression:
                                "strategy.Cash_Management_Frequency__c",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("sui-form-field", [
            _c("label", [_vm._v("Notes")]),
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.strategy.Cash_Management_Notes__c,
                  expression: "strategy.Cash_Management_Notes__c",
                },
              ],
              attrs: { name: "cash-management-notes", rows: "3" },
              domProps: { value: _vm.strategy.Cash_Management_Notes__c },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(
                    _vm.strategy,
                    "Cash_Management_Notes__c",
                    $event.target.value
                  )
                },
              },
            }),
          ]),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }